import { Component, OnInit,Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SharedDataService } from '../shared-data.service';

@Component({
  selector: 'app-recordtype',
  templateUrl: './recordtype.component.html',
  styleUrls: ['./recordtype.component.scss']
})
export class RecordtypeComponent implements OnInit {

  layoutData: any;

  constructor(private sharedDataService: SharedDataService) {}

  ngOnInit() {

  }

  next(){
    this.layoutData = {
      // Set your layout data here
    };
  }

  handleRecordtype(recordtype) {
    console.log("recordtype", recordtype);

  }

  save() {
    // Save logic here if needed

    // Retrieve data from the shared service
    this.sharedDataService.formData$.subscribe((data) => {
      // Perform save operation with the combined data
      // This could be an API call or any other saving mechanism
      console.log('Saving combined data:', data);
    });
  }
}
